module.exports = __webpack_public_path__ + "static/img/icon512.ec87796.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/hoopstack/icon512.jpg
// module id = dY1L
// module chunks = 0